import { TitleColor } from '..';
import Text from '../Text';

const Education2020 = () => (
  <>
    <TitleColor text="Kurser 2020" smallTitle />
    <Text>
      <b>Nordic Animal Behavior Conference</b>
      <br />
      Konference den 26.-28. juni: "Bridging the communication gap between humans and animals"
    </Text>
    <Text>
      <b>Sarah Owings</b>
      <br />
      Kursusforløb maj / juni: "Control is an illusion - Rethinking How We Teach for “Impulse
      Control”"
    </Text>
    <Text>
      <b>Iris Castaing</b>
      <br />
      Kursusforløb maj / juni: "Empowered dogs - Cooperative Husbandry Training"
    </Text>
    <Text>
      <b>Eva Bertilsson and Emelie Vegh</b>
      <br />
      Kursusforløb marts / april: "Seamlessness – from one reward to the next"
    </Text>
  </>
);

export default Education2020;
